// extracted by mini-css-extract-plugin
export var standaloneTable = "_h3-0";
export var withExtraHeader = "_h3-1";